module.exports = __webpack_public_path__ + "img/no_heatmap.cb4b3aa8.svg";